import React, { memo } from 'react'
import tw from 'twin.macro'
import { FormikFileInput } from 'src/components/shared/form/formik/FormikFileInput'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { CreateCustomerFormValues } from './CreateCustomerForm.interface'

const CreateCustomerFormContentComponent = () => {
  return (
    <div css={tw`flex flex-col gap-4`}>
      <FormikTextField<CreateCustomerFormValues> name="name" label="Customer name" />
      <FormikFileInput<CreateCustomerFormValues>
        name="logo"
        label="Logo"
        inputDataTestId="create-customer-logo-input"
      />
    </div>
  )
}

export const CreateCustomerFormContent = memo(CreateCustomerFormContentComponent)
